import * as codexEditor from 'app/codex/codemirror';
import { handleOutputGifs } from 'app/codex/utils';

/**
 * Shared contexts by codex env id
 * @type {object.<number, CodexSharedContext>}
 */
const activeSharedContexts = {};

class CodexSharedContext {
    /**
     * Codex shared context manager. Keeps track of shared-context codex state (edited code and
     * output) between problems/panes in a quiz.
     */
    constructor() {
        this.value = null;
        this.$output = null;
    }

    /**
     * Sets the value and output for a codex container from shared context. If the container has
     * output and there's no current shared output, this will update the shared output as well.
     * @param {JQuery} $container
     * @param {CodexCodeMirrorState} codexEditorState
     */
    applyContext($container, codexEditorState) {
        if (this.value) {
            codexEditor.setValue(codexEditorState, this.value);
            $container.find('.codex-textarea textarea').val(this.value);
        }

        if (this.$output) {
            const $existingOutput = $container.find('.codex-output');
            if ($existingOutput.length) {
                $existingOutput.replaceWith(this.$output);
            } else {
                $container.append(this.$output);
            }
            handleOutputGifs($container);
        } else {
            const $output = $container.find('.codex-output');
            if ($output.length) {
                this.$output = $output.clone();
            }
        }
    }

    /**
     * Set the shared context value (i.e. edited code)
     * @param {string} value
     */
    setValue(value) {
        this.value = value;
    }

    /** Clear the shared context output. This is used when executing code. */
    clearOutput() {
        this.$output = null;
    }
}

/**
 * Get the shared context object if one exists. If not, create a new one.
 * @param {number} envId
 */
export function getSharedContext(envId) {
    if (!activeSharedContexts[envId]) {
        activeSharedContexts[envId] = new CodexSharedContext();
    }

    return activeSharedContexts[envId];
}
